import { render, staticRenderFns } from "./SmOwCardOpinion.vue?vue&type=template&id=52e8b6a6&scoped=true&"
import script from "./SmOwCardOpinion.vue?vue&type=script&lang=ts&"
export * from "./SmOwCardOpinion.vue?vue&type=script&lang=ts&"
import style0 from "./SmOwCardOpinion.vue?vue&type=style&index=0&id=52e8b6a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e8b6a6",
  null
  
)

export default component.exports